import React from 'react';
import PropTypes from 'prop-types';
import { ChevronButton } from '@zola/zola-ui';

import './ChecklistNextTaskButton.less';

const ChecklistNextTaskButton = ({ disabled, goToNextTask }) => (
  <ChevronButton
    className="checklist__btn--next"
    btnStyle="tertiary"
    direction="right"
    disabled={disabled}
    onClick={goToNextTask}
  />
);

ChecklistNextTaskButton.propTypes = {
  disabled: PropTypes.bool,
  goToNextTask: PropTypes.func,
};

ChecklistNextTaskButton.defaultProps = {
  disabled: false,
};

export default ChecklistNextTaskButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistNextTaskButton/ChecklistNextTaskButton.jsx